import GamePanel from './GamePanel';

export default GamePanel;


// WEBPACK FOOTER //
// ./src/components/GamePanel/index.js